// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"112":"dab41732","413":"b37ea017","461":"5b3ac308","510":"6d165de0","548":"971af4c9"}[chunkId] + ".css";
};